import { AfterViewChecked, Component, Inject, OnDestroy, OnInit, PLATFORM_ID, Renderer2, ElementRef, NgZone, HostListener, ViewChild } from '@angular/core';
import { UtilsService } from '../../../shared/services/utils.service';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { ProductDetailService } from '../../../shared/services/product-detail.service';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { NotifyMeModalComponent } from '../../../shared/components/notify-me-modal/notify-me.component';
import { ShareProductModalComponent } from '../../../shared/components/share-product-modal/share-product-modal.component';
import { ChooseLocationModalComponent } from '../../../shared/components/choose-location-modal/choose-location-modal.component';
import { CartDetailsService } from '../../../shared/services/cart-details.service';
import { AnalyticsService } from '../../../shared/services/analytics.service';
import { MetaMgmtService } from '../../../shared/services/meta-mgmt.service';
import { DataLayerService } from '../../../shared/services/gtm-service/data-layer.service';
import { ServerSideResponseService } from '../../../shared/services/server-side-response.service';
import { environment } from '../../../environments/environment';
import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef } from '@angular/core';
import { SchemaService } from '../../../shared/services/schema.service';
import { Subscription } from 'rxjs/internal/Subscription';
// import { PrebookModalComponent } from '../../../shared/components/prebook-modal/prebook-modal.component';
import { MatTabsModule } from '@angular/material/tabs';
import { FaqPageComponent } from '../faq-page/faq-page.component';
import { AllReviewsComponent } from '../../../shared/components/all-reviews/all-reviews.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { CarousalPageComponent } from '../../../shared/components/carousal-page/carousal-page.component';
import { CartService } from '../../../shared/services/cart.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SecurityContext } from '@angular/core';
import { ImageZoomComponent } from '../../../shared/components/image-zoom/image-zoom.component';
import { SafehtmlPipe } from '../../../shared/pipes/safehtml.pipe';
import { TruncatePipe } from '../../../shared/pipes/truncate.pipe';

declare const gtag: any;

@Component({
  selector: 'app-product-detail',
  standalone: true,
  imports: [CommonModule,MatTabsModule,FaqPageComponent,AllReviewsComponent,SafehtmlPipe,MatExpansionModule,TruncatePipe,CarouselModule,CarousalPageComponent,ImageZoomComponent],
  templateUrl: './product-detail.component.html',
  styleUrl: './product-detail.component.scss'
})
export class ProductDetailComponent implements OnInit, AfterViewChecked, OnDestroy {
  environment = environment;
  productResponse: any = {};
  discountedPrice: any;
  discountPercentage: any;
  productGuidId: any;
  pinCode: any;
  userGuidId: any;
  sub:Subscription=new Subscription()
  imageObject: Array<any> = [
  ];
  showFlag: boolean = false;
  showPopup: boolean = false;
  selectedImageIndex: number = -1;
  showPage: boolean = false;
  isEshop: boolean = false;
  isProductAvailable: boolean = true;
  selectedVariantIndex: number = 0;
  cart: any;
  productCart: any = [];
  productQuantity: number = 1;

  snapmintScript: any;
  src: any;
  customOptions: OwlOptions = {
    loop: true,
    autoplay: false,
    center: false,
    dots: true,
    autoHeight: true,
    stagePadding: 0,
    lazyLoad: true,
    margin: 0,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      1000: {
        items: 1,
      }
    }
  }
  pageName!: string;
  showSpan: boolean = true;
  warrantyDocUrl!: string;
  @ViewChild('videoPlayer') videoPlayer!: ElementRef;
  script: any;
  actualSchemaValue: any;
  matchedPath: boolean = false;
  paths = [
    'ab36060',
    'ab30060',
    'ab24060',
    'ab18060'
  ];
  showButtonsforCombos: boolean = true;
  product:any;
  isPlayButtonVisible: boolean = true;
  mainImg: any;
  activeTab: string = 'overview';
  constructor(
    public utils: UtilsService,
    public service: ProductDetailService,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    public router: Router,
    public analyticsService: AnalyticsService,
    public cartService: CartService,
    private cartDetailsService: CartDetailsService,
    private metaSvc: MetaMgmtService,
    private serverResponse: ServerSideResponseService,
    private cd: ChangeDetectorRef,
    private _renderer2: Renderer2,
    private sanitizer: DomSanitizer,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private _document: Document,
    private _dataLayerService: DataLayerService,
    private schemaService: SchemaService) {
    const resolvedData = this.route.snapshot.data['resolvedData'];
    if (resolvedData && resolvedData.res && resolvedData.res.url) {
      this.serverResponse.setStatusCode(301);
      this.router.navigate([resolvedData.res.url])
    }
  }

  ngOnInit(): void {
    this.utils.showLoading()
    this.matchedPath = !!this.matchesAnyPath();

      this.pinCode = this.utils.getUserPicode() ? this.utils.getUserPicode() : 0;
    this.sub.add( this.route.params.subscribe(params => {
      this.productGuidId = params['guidId'];
      this.pageName = params['productName'];
      this.productGuidId || this.pageName ? this.getProductInfo(this.productGuidId) : ''

    }))
     if (isPlatformBrowser(this.platformId)) {

    this.utils.showHeaderFooter.next(true);
    this.userGuidId = localStorage.getItem('userGuidId') ? localStorage.getItem('userGuidId') : ''
    this.sub.add( this.cartService.cartData$.subscribe(
      (data: any) => {
        this.productCart = data;
      }));
  }

}
async callSchema(){
  this.actualSchemaValue = await this.schemaService.addSchema();
  const jsonString = JSON.stringify(this.actualSchemaValue);
  const safeJson = this.sanitizer.bypassSecurityTrustHtml(jsonString);
  this.script  = this._renderer2.createElement('script');
  this.script.type = `application/ld+json`;
  this.script.text = safeJson as string;
  // this.script.text = JSON.stringify(this.actualSchemaValue);
  this._renderer2.appendChild(this._document.body, this.script);

}

  ngAfterViewChecked() {
    this.createScript();
  }

  ngAfterViewInit() {
    this.observeDOMChanges();
  }

  observeDOMChanges(): void {
    if (isPlatformBrowser(this.platformId)) {
      const observer = new MutationObserver(() => {
        const spanElement = document.querySelector('.snap-emi-slogan span');
        if (spanElement) {
          const additionalTextHtml = '10% Cashback up to ₹1000 in Snapmint wallet (T&C Apply), ';
          const additionalTextElement = this._renderer2.createElement('span');
          this._renderer2.setProperty(additionalTextElement, 'innerHTML', additionalTextHtml);
    
          // Insert the new span as a sibling before the existing span
          this._renderer2.insertBefore(spanElement.parentNode, additionalTextElement, spanElement);
  
          this.applyResponsiveStyles();
  
          observer.disconnect();
        }
      });
    
      observer.observe(document.body, { childList: true, subtree: true });
    }

  }
  
  applyResponsiveStyles(): void {
    if(isPlatformBrowser(this.platformId)) { 
      const divElement = document.querySelector('.snap-emi-slogan');
      if (divElement) {
        const bElement = divElement.querySelector('b');
        if (bElement) {
          if (window.innerWidth <= 767) { // Mobile view
            this._renderer2.setStyle(bElement, 'display', 'flex');
            this._renderer2.setStyle(bElement, 'flex-direction', 'column');
          } else { // Web view
            this._renderer2.setStyle(bElement, 'display', 'block');
            this._renderer2.setStyle(bElement, 'flex-direction', 'initial');
          }
        }
      }
    }
  }
  

  createScript() {
    if (isPlatformBrowser(this.platformId)) {

    if (this.snapmintScript) {
      this.snapmintScript.remove();
    }
    var myEle = document.getElementsByClassName("snapmint_lowest_emi_value");
    if (this.productResponse && myEle.length > 0 && myEle[0].hasAttribute('data-snapmint-price') && this.snapmintScript == null) {
      const scriptSrc = ('https:' == document.location.protocol ? 'https://' : 'https://') +
      `assets.snapmint.com/assets/merchant/${environment.merchantId}/snapmint_emi.js`;
  
    // Sanitize the script URL
    const safeScriptSrc: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(scriptSrc);
        this.snapmintScript = document.createElement('script');
        this.snapmintScript.type = 'text/javascript';
        this.snapmintScript.async = true;
        this.snapmintScript.id = "snapmintProductDetail";
        this.snapmintScript.src = this.sanitizer.sanitize(SecurityContext.RESOURCE_URL, safeScriptSrc) || '';;
        document.getElementsByTagName('head')[0].appendChild(this.snapmintScript);
    }
  }
  }
  getPrice() {
    if (this.productResponse && this.productResponse.productMRP)
      return this.productResponse?.productMRP;
  }
  matchesAnyPath(): boolean {
    const urlSegment = this.router.url.match(/\/product\/(.+)/)?.[1];
    return !!(urlSegment && this.paths.includes(urlSegment));
  }
  triggerProductViewed() {
    if (isPlatformBrowser(this.platformId)) {

    const productInfo = JSON.parse(this.utils.getProductInfo());
    const gtmData = {
      eventName: "Product Viewed",
      eventData: {
        'Pin Code': Number(this.utils.getUserPicode()),
        'Product Name': this.cart.productName,
        'Product Price_before': this.cart.productMRP,
        'In Stock': this.cart.productInventoryCount > 0 ? true : false,
        'Category Name': productInfo && productInfo.category ? productInfo.category : '',
        'Sub-category name': productInfo && productInfo.brandSubCategoriesMenus.subCategory ? productInfo.brandSubCategoriesMenus.subCategory : '',
        'Series Name': productInfo && productInfo.seriesName ? productInfo.seriesName : '',
        'Description': this.utils.convertHTMLtoString(this.productResponse.shortDescription),
        'Product Images': this.productResponse.landingPageImages,
        'Source': localStorage.getItem('source') ? localStorage.getItem('source') : 'Others',
        'Product price_after': this.productResponse.inventory ? this.cart.sellingPrice : this.cart.productMRP,
      }
    };
    this.analyticsService.trackData(gtmData);
  }}

  buynowClicked() {
    if (this.utils.getUserPicode()) {
      let cart: any = []
      this.cart.quantity = this.productQuantity
      cart.push(this.cart)
      this.cartService.setInfo(cart, true)
      this.triggerBuyNowEvent();
      this._dataLayerService.triggerCartEvents('add_to_cart')
      this.router.navigate(['/checkout/shipping-details'])
    }
    else {
      this.openLocationDialog(true, false);
    }
  }

  triggerBuyNowEvent() {
    if (isPlatformBrowser(this.platformId)) {

    const productInfo = JSON.parse(this.utils.getProductInfo());
    const gtmData = {
      eventName: "Buy now",
      eventData: {
        'Source': localStorage.getItem('source') ? localStorage.getItem('source') : 'Others',
        'Pin Code': Number(this.utils.getUserPicode()),
        'Product Name': this.cart.productName,
        'Product Price_before': this.cart.productMRP,
        'In Stock': this.cart.productInventoryCount > 0 ? true : false,
        'Category Name': (productInfo && productInfo.category) ? productInfo.category : '',
        'Sub-category name': (productInfo && productInfo.brandSubCategoriesMenus.subCategory) ? productInfo.brandSubCategoriesMenus.subCategory : '',
        'Series Name': productInfo && productInfo.seriesName ? productInfo.seriesName : '',
        'Product Images': this.productResponse.landingPageImages,
        'Product price_after': this.cart.sellingPrice,
        'Variants': this.productResponse && this.productResponse.variantList[0] && this.productResponse.variantList[0].productName ? this.productResponse.variantList[0].productName : '',
        'Total Quantity': this.productQuantity
      }
    };
    this.analyticsService.trackData(gtmData);
    this.cartDetailsService.triggerCartUpdate();
    if (isPlatformBrowser(this.platformId)) {
      gtag('event', 'conversion', {
        value: this.cart.sellingPrice,
        currency: 'INR',
        event_callback: 'callback'
      });
    }
  }
}

  getProductInfo(data: any) {
    let emptyGuid = "00000000-0000-0000-0000-000000000000";
    let body =
    {
      "productGuidId": data ? data : emptyGuid,
      "productName": this.pageName,
      "pinCode": this.pinCode
    }
    this.utils.showLoading()
    this.sub.add(this.service.getDistributorsProductInfo(body).subscribe({
      next: (response: any) => {
        if (response.success) {
          this.utils.hideLoading();
          const { productName, featureImageFile, shortDescription } = response;
          const filteredObject = { productName, featureImageFile, shortDescription };
        this.schemaService.sendData(filteredObject);
          response.metaInfoResponse['canonicalURL'] = environment.baseApiURl + this.router.url
          this.metaSvc.updateMetaTags(response.metaInfoResponse ? response.metaInfoResponse : {})
          this.setProductData(response);
        }
        else if (!response.success) {
          this.showPage = true;
          this.utils.hideLoading()
          this.router.navigate(['/'])
        }
        else {
          this.utils.hideLoading()
          this.utils.openSnackBar('Cannot fetch details', 'error-toster')
        }
      },
      complete:()=>{
      this.callSchema();
      }
    }))
  }

  triggerGtaProductViewed() {
    const productInfo = this.utils.getProductInfo() ? JSON.parse(this.utils.getProductInfo()) : '';

    let itemArray = [];

    itemArray = [{
      'item_id': this.productResponse.productSku || '',
      'item_name': this.productResponse.productName,
      'item_brand': productInfo && productInfo.seriesName ? productInfo.seriesName : '',
      'currency': 'INR',
      'discount': this.productResponse.sellingPrice ? this.productResponse.productMRP - this.productResponse.sellingPrice : 0,
      'item_category': (productInfo && productInfo.category) ? productInfo.category : '',
      'item_category2': productInfo && productInfo.brandSubCategoriesMenus.subCategory ? productInfo.brandSubCategoriesMenus.subCategory : '',
      'item_category4': (this.productResponse.specificationList).find((element: any) => element.description == 'VA Rating')?.value || 'NA',
      'item_category5': (this.productResponse.specificationList).find((element: any) => element.description == 'Technology')?.value || 'NA',
      'price': this.productResponse.sellingPrice ? this.productResponse.sellingPrice : this.productResponse.productMRP,
      'item_list_name': 'NA',
      'item_list_id': 'NA',
      'item_variant': (this.productResponse.specificationList).find((element: any) => element.description == 'Warranty')?.value || 'NA',
      'index': 0,
    }
    ]
    this._dataLayerService.triggerEvents(itemArray, 'view_item')
  }

  getSpecification(type: any) {
    this.productResponse.specificationList.map((data: any) => {
      if (data['description'] === type) {
        return data.value
      }
    })
  }

  valueEmitted(event?: any, productName?: any) {
    let name = this.utils.createNameForUrl(productName ? productName : '')
    this.router.navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate(['product', name, event]));
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(NotifyMeModalComponent, {
      disableClose: true,
      maxWidth: '592px',
      width: '100%',
      data: {
        productGuidId: this.pageName,
        userGuidId: this.userGuidId,
        pinCode: this.utils.getUserPicode(),
        cart: this.cart,
        productResponse: this.productResponse
      }
    });
    this.sub.add(dialogRef.afterClosed().subscribe((res) => {
    }));
  }



  openShareDialog(): void {
    const dialogRef = this.dialog.open(ShareProductModalComponent, {
      disableClose: true,
      maxWidth: '417px',
      width: '100%',
      panelClass: 'productShareModel',
      data: {
        productGuidId: this.productGuidId,
        productName: this.productResponse && this.productResponse.productName ? this.productResponse.productName : ''
      }
    });


    this.sub.add(dialogRef.backdropClick().subscribe(() => {
      dialogRef.close();
    }));

    this.sub.add(dialogRef.afterClosed().subscribe((res) => {
      dialogRef.close();

    }));
  }


  openLocationDialog(isBuyNow?: boolean, isAddToCart?: boolean): void {
    const dialogRef = this.dialog.open(ChooseLocationModalComponent, {
      disableClose: true,
      panelClass:"chposeloc",
      data: this.utils.getUserPicode()
    });
    this.sub.add( dialogRef.afterClosed().subscribe((res) => {
      if (res) {

        this.pinCode = this.utils.getUserPicode();
        this.onSubmit()

      }
    }));
    dialogRef.afterClosed().subscribe((res) => {
    });
  }

  getProductDiscount(data: any) {
    this.discountedPrice = data.productMRP + data.discount - data.sellingPrice;
    this.discountPercentage = (this.discountedPrice / data.productMRP) * 100
  }

  getDataByAvailableAt(availableAt: any) {
    let obj = {
      image: '',
      name: ''
    };
    switch (availableAt.toLowerCase()) {
      case 'luminous': {
        obj.image = environment?.blobUrl+'/assets/icons/LuminousLogoBlue.webp';
        obj.name = 'E-Shop';
        break;
      }
      case 'flipkart': {
        obj.image = environment?.blobUrl + '/assets/icons/flipkart.svg'
        obj.name = 'Flipkart';
        break;
      }
      case 'amazon': {
        obj.image = environment?.blobUrl+'/assets/icons/amazon.svg'
        obj.name = 'Amazon';
        break;
      }
      case 'nearby': {
        obj.image = environment?.blobUrl+'/assets/icons/shop.svg'
        obj.name = 'Nearby Store';
        break;
      }
    }
    return obj;
  }

  onClickLandingImages(data: any) {
    if (this.isVideo(data)) {
      this.productResponse.featureImageFile = data;
      this.isPlayButtonVisible = true;
    } else if (this.isImage(data)) {
      this.productResponse.featureImageFile = data;
    } else {
      console.error('Clicked item type unrecognized:', data);
    }
  }

  redirectTo(_data: any) {
    if(isPlatformBrowser(this.platformId)) {
      if ((window as any).fbq) {
        (window as any).fbq('track', 'AddToCart');
      } else {
        console.log('Facebook Pixel not loaded.');
      }
      this.triggerAvailableAt(_data);
      if (_data.availableAt == "nearBy") {
        this.router.navigate(['store-locator'])
      }
      else {
        window.open(_data.productLink)
      }
    }
  }

  triggerAvailableAt(data: any) {
    const productInfo = JSON.parse(this.utils.getProductInfo());
    const gtmData = {
      eventName: "Availability Shop Viewed",
      eventData: {
        'Store Viewed': this.getDataByAvailableAt(data.availableAt).name,
        'Series Name': productInfo.seriesName || ''
      }
    };
    this.analyticsService.trackData(gtmData);
    if (isPlatformBrowser(this.platformId)) {
      gtag('event', 'conversion', {
        send_to: 'AW-852878965/vYljCMmn5ooDEPXM15YD',
        event_callback: 'callback',
        value: this.productResponse.sellingPrice,
        currency: 'INR'
      });
    }
  }

  showLightbox(index: any) {
    this.selectedImageIndex = index;
  
    this.imageObject = this.productResponse.landingPageImages;

    this.showFlag = true;
  }
  
  videoLoaded(): void {
    this.utils.hideLoading();
  }
  
  closeFullscreen() {
    this.showFlag = false;
  }
  
  showNextImage() {
    if (this.selectedImageIndex < this.imageObject.length - 1) {
      this.selectedImageIndex++;
    } else {
      this.selectedImageIndex = 0;
    }
  }
  
  showPrevImage() {
    if (this.selectedImageIndex > 0) {
      this.selectedImageIndex--;
    } else {
      this.selectedImageIndex = this.imageObject.length - 1; // Loop to the last image
    }
  }
   
  


  closeEventHandler() {
    this.showFlag = false;
    this.selectedImageIndex = -1;
  }

  onSubmit() {
    if (isPlatformBrowser(this.platformId)) {

    this.showSpan=false;
    let body =
    {
      "productGuidId": this.productGuidId,
      "productName": this.pageName,
      "pinCode": this.pinCode
    }
    this.utils.showLoading();
    this.pinCode = this.utils.getUserPicode();
    this.sub.add( this.service.getDistributorsProductInfo(body).subscribe({
      next: (response: any) => {
        this.utils.hideLoading()
        this.showSpan=true;
        if (response.success && response.distributorProductInventoryGuidId) {
          this.setProductData(response);
           let myEle = document.getElementsByClassName("snap_emi_txt");
           this.addScript();
        }
        else if (response.success && !response.distributorProductInventoryGuidId) {
          this.setProductData(response);
           let myEle = document.getElementById("snap_emi_txt");
           this.addScript();
          this.isProductAvailable = false;
        }
        else {
          this.utils.hideLoading();
          this.utils.openSnackBar(response.message, 'error-toster')
        }
      }
    }))
  }
}
addScript(){
  if (isPlatformBrowser(this.platformId)) {
    const scriptSrc = ('https:' == document.location.protocol ? 'https://' : 'https://') +
    `assets.snapmint.com/assets/merchant/${environment.merchantId}/snapmint_emi.js`;

  // Sanitize the script URL
  const safeScriptSrc: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(scriptSrc);
  this.snapmintScript = document.createElement('script');
  this.snapmintScript.type = 'text/javascript';
  this.snapmintScript.async = true;
  this.snapmintScript.id = "snapmintProductDetail";
  this.snapmintScript.src = safeScriptSrc as string; 
  
}}

  setImageIndex(index: any) {
    this.selectedImageIndex = index
  }

  setVariantIndex(index: any) {
    this.selectedVariantIndex = index
  }

  cartObject() {
    this.cart = {
      inventoryGuId: this.productResponse.distributorProductInventoryGuidId,
      userGuidId: this.userGuidId,
      maxQuantity: this.productResponse.maximumQuantity,
      productName: this.productResponse.productName,
      productMRP: this.productResponse.productMRP,
      productMSP: this.productResponse.productMSP,
      taxPercent: this.productResponse.combinedGstTax,
      pincode: this.utils.getUserPicode(),
      productImageFileName: this.productResponse.featureImageFile,
      productInventoryCount: this.productResponse.inventory,
      quantity: 0,
      sellingPrice: this.productResponse.sellingPrice,
      deliverySLA: this.productResponse.deliverySLA,
      discount: this.productResponse.discount,
      productGuId: this.productResponse.productGuidId,
      distributorGuid: this.productResponse.distributorGuid,
      inventory: this.productResponse.inventory,
      specificationList: this.productResponse.specificationList,
      productSku: this.productResponse.productSku
    }
    this.triggerGtaProductViewed();
    this.triggerProductViewed();
  }

  addToCart() {
    if (isPlatformBrowser(this.platformId)) {
      if ((window as any).fbq) {
        (window as any).fbq('track', 'AddToCart');
      } else {
        console.log('Facebook Pixel not loaded.');
      }
    if (!this.utils.getUserPicode()) {
      this.openLocationDialog(false, true);
    }
    else {
      let cart: any = this.productCart ? this.productCart : [];
      if (cart) {
        let found = cart.some((element: any) => this.cart.productGuId == element.productGuId)
        if (found) {
          const index = cart.findIndex((element: any) => { return element.productGuId == this.cart.productGuId })
          let totalQuantityAfterAdding = cart[index].quantity + this.productQuantity;
          if ((totalQuantityAfterAdding <= cart[index].maxQuantity) && (totalQuantityAfterAdding <= cart[index].productInventoryCount)) {
            cart[index].quantity = cart[index].quantity + this.productQuantity
            this.cart.quantity = cart[index].quantity
          }
          else if (
            ((totalQuantityAfterAdding - this.productQuantity) < cart[index].maxQuantity) &&
            ((totalQuantityAfterAdding - this.productQuantity) < cart[index].productInventoryCount)
          ) {
            cart[index].quantity = cart[index].productInventoryCount <= cart[index].maxQuantity ? cart[index].productInventoryCount : cart[index].maxQuantity;
            this.cart.quantity = cart[index].quantity;
            this.utils.openCartChangeDialog(() => { });
          }
          else {
            this.utils.openSnackBar('Maximum quantity for a user is already added for this product', 'error-toster');
          }
        }
        else {
          this.cart.quantity = this.productQuantity
          cart.push(this.cart)
        }
        if (this.utils.getUser()) {
          this.cartService.setInfo(cart, false)
          this.sub.add( this.cartDetailsService.checkout().subscribe((data: any) => {
            if (data.success) {
              this.triggerAddToCartEvent()
              this._dataLayerService.triggerAddRemoveEvent('add_to_cart', this.cart)
              this.analyticsService.triggerCartViewed();
              this.router.navigate(['/cart-details'])
            }
            else if (!data.success) {
              this.utils.openSnackBar('Internal server error', 'error-toster')
            }
          }))
        }
        else if (!this.utils.getUser()) {
          this.cartService.setInfo(cart, false);
          let timeStamp: any = new Date().getTime();
          localStorage.setItem('startTime', JSON.stringify(timeStamp));
          this._dataLayerService.triggerAddRemoveEvent('add_to_cart', this.cart)
          this.triggerAddToCartEvent();
          this.analyticsService.triggerCartViewed();
          this.cartDetailsService.triggerCartUpdate();
          this.router.navigate(['/cart-details'])
        }
      }
      else if (!cart) {
        this.cart.quantity = this.productQuantity
        this.cartService.setInfo(this.cart, false)
      }
    }
  }
  }


  triggerAddToCartEvent() {
    if (isPlatformBrowser(this.platformId)) {

    const productInfo = JSON.parse(this.utils.getProductInfo());
    const gtmData = {
      eventName: "Add to Cart",
      eventData: {
        'Source': localStorage.getItem('source') ? localStorage.getItem('source') : 'Others',
        'Pin Code': Number(this.utils.getUserPicode()),
        'Product Name': this.cart.productName,
        'Product Price_before': this.cart.productMRP,
        'In Stock': this.cart.productInventoryCount > 0 ? true : false,
        'Category Name': productInfo?.category || '',
        'Sub-category name': productInfo?.brandSubCategoriesMenus?.subCategory || '',
        'Series Name': productInfo?.seriesName || '',
        'Product Images': this.productResponse.landingPageImages,
        'Product price_after': this.cart.sellingPrice,
        'Variants': this.productResponse && this.productResponse.variantList[0] && this.productResponse.variantList[0].productName ? this.productResponse.variantList[0].productName : '',
        'Total Quantity': this.productQuantity || 0
      }
    };
    this.analyticsService.trackData(gtmData);
    if (isPlatformBrowser(this.platformId)) {
      gtag('event', 'conversion', {
        send_to: 'AW-852878965/vYljCMmn5ooDEPXM15YD',
        event_callback: 'callback  ',
        value: this.productResponse.sellingPrice,
        currency: 'INR'
      });
    }
  }
}

  increaseQuantity() {
    if (this.productQuantity < this.productResponse.inventory && this.productQuantity < this.productResponse.maximumQuantity) {
      this.productQuantity++
    }
    else {
      this.utils.openSnackBar(`You can buy only up to ${this.productQuantity} unit(s) of this product`, 'error-toster')
    }
  }

  decreaseQuantity() {
    if (this.productQuantity > 1) {
      this.productQuantity--
    }
  }

  getProductQuantity() {
    let cart: any = this.productCart ? this.productCart : []
    let found = cart.some((element: any) => this.productResponse.productGuId == element.productGuId)
    if (found) {
      const index = cart.findIndex((element: any) => { return element.productGuId == this.productResponse.productGuId })
      this.productResponse.maximumQuantity = this.productResponse.maximumQuantity - cart[index].quantity
    }
  }

  setProductData(productData: any) {
    const currentUrl = this.router.url; 
  
    this.productResponse.inventory = productData.inventory;
    this.productResponse.productOverview = productData.productOverview;
    this.productResponse.distributorProductInventoryGuidId = productData.distributorProductInventoryGuidId;
    this.productResponse.maximumQuantity = productData.maximumQuantity;
    this.productResponse.productName = productData.productName;
    this.productResponse.productMRP = productData.productMRP;
    this.productResponse.productMSP = productData.productMSP;
    this.productResponse.combinedGstTax = productData.combinedGstTax;
    this.productResponse.featureImageFile = productData.featureImageFile ? productData.featureImageFile : '';
    this.productResponse.inventory = productData.inventory;
    this.productResponse.sellingPrice = productData.sellingPrice;
    this.productResponse.deliverySLA = productData.deliverySLA;
    this.productResponse.similarProduct = productData.similarProduct ? productData.similarProduct : [];
    this.productResponse.frequentlyBoughtTogether = productData.frequentlyBoughtTogether ? productData.frequentlyBoughtTogether : [];
    this.productResponse.questionAnswer = productData.questionAnswer ? productData.questionAnswer : [];
    this.productResponse.sellingOption = productData.sellingOption ? productData.sellingOption : [];
    this.productResponse.variantList = productData.variantList ? productData.variantList : [];
    this.productResponse.specificationList = productData.specificationList ? productData.specificationList : [];
    this.productResponse.maufacturerList = productData.maufacturerList ? productData.maufacturerList : [];
    this.productResponse.shortDescription = productData.shortDescription ? productData.shortDescription : '';
    this.productResponse.discount = productData.discount ? productData.discount : 0;
    this.productResponse.distributorGuid = productData.distributorGuid;
    this.productResponse.isWishList = productData.isWishList ? productData.isWishList : '';
    this.productResponse.reviewData = productData.reviewData ? productData.reviewData : '';
  
    const images = productData.landingImages ? productData.landingImages.map((image: any) => image.productImageFile) : [];
  
    // Check if the URL contains any of the specified paths
    const shouldAddVideo = this.paths.some(path => 
      (currentUrl.split("/product/")[1] || "") === path
    );    
    
  
    if (shouldAddVideo) {
      const staticVideo = 'https://lumprodsta.blob.core.windows.net/prodcontainer/ProductHighlightVideos/Amp_Series_video.m4v';
      images.push(staticVideo);
    }
    this.productResponse.landingPageImages = images;
    this.productResponse.landingPageImages.unshift(this.productResponse.featureImageFile);
    this.productResponse.productGuidId = productData.productGuidId;
    this.productResponse.productSku = productData.productSKU;
  
    this.productResponse.sellingOption.forEach((element: any) => {
      if (element.availableAt === 'eshop' && element.isActive) {
        this.isEshop = true;
      }
    });
  
    this.productResponse.warrantyDocUrl = productData.productOverview ? '' + productData?.productOverview?.warrantyDocUniqueFileName : '';
  
    this.service.getComboProductsVisible(this.productResponse.productGuidId).subscribe(
      (response: any) => {
        this.showButtonsforCombos = response?.comboProductsVisibleById ? !response.comboProductsVisibleById.isActive : true;
      }
    );
  
    this.getProductDiscount(productData);
    this.cartObject();
    this.getProductQuantity();
    this.cd.markForCheck();

    this.showPage = true;
    this.utils.hideLoading();
    if (isPlatformBrowser(this.platformId)) {
      window.scrollTo(0, 0);
    }
    this.cd.detectChanges();
  }
  
  isImage(url: string): boolean {
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp']; // Add more if needed
    const ext = url.split('.').pop()?.toLowerCase();
    return ext ? imageExtensions.includes(ext) : false;
  }
  
  isVideo(url: string): boolean {
    const videoExtensions = ['mp4', 'avi', 'mov', 'wmv', 'flv','m4v']; // Add more if needed
    const ext = url.split('.').pop()?.toLowerCase();
    return ext ? videoExtensions.includes(ext) : false;
  } 
  toggleVideoPlay(video: HTMLVideoElement) {

    if (!video) return;
    if (video.paused || video.ended) {
      video.play();
      this.isPlayButtonVisible = false;
    } else {
      video.pause();
      this.isPlayButtonVisible = true;
    }
    this.cd.detectChanges();
  }
  checkVisibility(dataToCheck: []) {
    let filteredVal: any = dataToCheck.filter((ele: any) => {
      let val = ele.value.trim()
      if (val && val.length) { return ele }
    })
    if (filteredVal && filteredVal.length) {
      return true;
    }
    else
      return false;
  }

  valueTrimAndCheckVisibility(val: any) {
    let value = val.trim();
    if (value && value.length) {
      return true
    }
    else return false;
  }

  addEditWishList(value: any) {
    if (this.utils.getToken()) {
      this.utils.showLoading()
      let data = {
        productComboName: this.pageName,
        type: value
      }
      this.sub.add(  this.service.updateWishList(data).subscribe(
        (response: any) => {
          if (response.success) {
            if (value.toLowerCase() == 'add') {
              if(isPlatformBrowser(this.platformId)) {  
                if ((window as any).fbq) {
                  (window as any).fbq('track', 'AddToWishlist');
                } else {
                }
              }
            }
            this.utils.hideLoading()
            this.utils.openSnackBar(value.toLowerCase() == 'add' ? 'Added to your saved items' : 'Removed from your saved items', 'success-toster')
            this.productResponse.isWishList = !this.productResponse.isWishList
          }
          else if (!response.success) {
            this.utils.hideLoading()
            this.utils.openSnackBar(response.message, 'error-toster')
          }
        }
      ))
    }
    else {
      this.utils.openSnackBar('Please login first to add product', 'error-toster')

    }
  }


  getLoadChartData(loadChartData: any) {
    let objectForloadChart: any = {
      'totalWatt': {
        caseA: '',
        caseB: ''
      },
      'batteryOptions': {
        valueArray: [],
        displayValue: 'Battery Options(KWh)',
      },
      'backUpAt75': {
        valueArray: [],
        displayValue: 'Backup Time*(@75% Load) Hrs'
      },
      'backUpAt50': {
        valueArray: [],
        displayValue: 'Backup Time*(@50% Load) Hrs'
      },
    }
    if (loadChartData && loadChartData.length) {
      for (const arr of loadChartData) {
        if (arr.description.toLowerCase().split(' ').join('') == 'battery-casea' || arr.description.toLowerCase().split(' ').join('') == 'battery-caseb') {
          objectForloadChart['batteryOptions'].valueArray.push(this.valueTrimAndCheckVisibility(arr.value) ? arr.value : '');
        }
        else if (arr.description.toLowerCase().split(' ').join('') == 'backuptime(75%ofpeakload)batterya' || arr.description.toLowerCase().split(' ').join('') == 'backuptime(75%ofpeakload)batteryb') {
          objectForloadChart['backUpAt75'].valueArray.push(this.valueTrimAndCheckVisibility(arr.value) ? arr.value : '');
        }
        else if (arr.description.toLowerCase().split(' ').join('') == 'backuptime(50%ofpeakload)batterya' || arr.description.toLowerCase().split(' ').join('') == 'backuptime(50%ofpeakload)batteryb') {
          objectForloadChart['backUpAt50'].valueArray.push(this.valueTrimAndCheckVisibility(arr.value) ? arr.value : '');
        }
        else if (arr.description.toLowerCase().split(' ').join('') == 'totalwatt-casea') {
          objectForloadChart['totalWatt'].caseA = this.valueTrimAndCheckVisibility(arr.value) ? arr.value : '';
        }
        else if (arr.description.toLowerCase().split(' ').join('') == 'totalwatt-caseb') {
          objectForloadChart['totalWatt'].caseB = this.valueTrimAndCheckVisibility(arr.value) ? arr.value : '';
        }
        else {
          objectForloadChart['considerations'] = arr.value ? arr.value : '';
        }
      }
      return objectForloadChart;
    }
    else {
      return false;
    }
  }

  showHidePopup() {
    this.showPopup = !this.showPopup;
  }

  zoomIn(event: MouseEvent) {
    const zoomBox = document.getElementById('zoom-box') as HTMLElement;
    
    if (zoomBox) {
        const targetElement = event.target as HTMLImageElement;  // Cast to HTMLImageElement to access src
        
        // Make sure the target element is an image and has a src attribute
        if (targetElement && targetElement.src) {
            const imageUrl = targetElement.src;  // Get image URL from the target element
            
            // Calculate position relative to the hovered element
            const rect = targetElement.getBoundingClientRect();

            // Set zoom box styles
            zoomBox.style.display = 'block';
            zoomBox.style.backgroundImage = `url("${imageUrl}")`;  // Set background image to the target image's src
            zoomBox.style.backgroundRepeat = 'no-repeat';
            zoomBox.style.backgroundSize = '250%';  // Adjust this value to control the zoom level
            zoomBox.style.top = `${rect.top}px`;  // Align vertically
            zoomBox.style.left = `${rect.right + 10}px`;  // Position beside the element with a 10px gap

            this.moveZoom(event);
        } else {
            console.error('Target element is not an image or does not have a src attribute.');
        }
    } else {
        console.error('zoomBox not found.');
    }
}


moveZoom(event: MouseEvent) {
    const zoomBox = document.getElementById('zoom-box') as HTMLElement;

    if (zoomBox) {
        const targetElement = event.target as HTMLElement;
        const rect = targetElement.getBoundingClientRect();
        const x = event.clientX - rect.left; // X position within the element
        const y = event.clientY - rect.top;  // Y position within the element

        const xPercent = `${(x / rect.width) * 100}%`;
        const yPercent = `${(y / rect.height) * 100}%`;

        zoomBox.style.backgroundPosition = `${xPercent} ${yPercent}`;
    }
}

zoomOut() {
    const zoomBox = document.getElementById('zoom-box') as HTMLElement;
    if (zoomBox) {
        zoomBox.style.display = 'none';
    }
}
openFullscreen(index: number, src: string) {
  this.selectedImageIndex = index;
  this.showFlag = true;
}
setActiveTab(tab: string): void {
  this.activeTab = tab;
}

  ngOnDestroy(): void {
this.sub.unsubscribe()
  }
}

